import { ObservationDTO, RequestDTO } from "@/Common/Api/Labs/Dto/Responses/LabMessageGroupDTO";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { LabTabViews } from "@/Common/Models/UI/Enums";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { LabsStore } from "@/Labs/Stores/LabsStore";

class LabGraphsHandler extends BaseOperationHandler {
    private helper = new MyleHelper();

    constructor() {
        super();

        this.RegisterOperation(LocalOperations.LabsUI.Graphs_ShowGraphs, this.ShowGraphs);
        this.RegisterOperation(LocalOperations.LabsUI.Graphs_BackToResults, this.BackToResults);
        this.RegisterOperation(LocalOperations.LabsUI.Graphs_CheckboxChange, this.CheckboxChange);
    }

    private ShowGraphs(request: LocalEvent, store: LabsStore): void {
        const patientContactId = request.Get<string>("patientContactId");
        const healthCardNumber = request.Get<string>("healthCardNumber");
        const selectedLabRequest = request.Get<RequestDTO>("lab");
        const selectedObservation = request.Get<ObservationDTO>("observationtype");

        const selectedObxs = selectedLabRequest && selectedLabRequest.ObservationsList && selectedLabRequest.ObservationsList.map(p => p.Identifier) || [];
        if (selectedObservation)
            selectedObxs.push(selectedObservation.Identifier);

        store.LabActions.LoadGraphData(patientContactId, selectedObxs, healthCardNumber);
    }

    private BackToResults(request: LocalEvent, store: LabsStore): void {
        store.Model = store.Model.set("CurrentView", LabTabViews.Lab);
        store.ResetGraphsModel();
    }

    private CheckboxChange(request: LocalEvent, store: LabsStore): void {
        let target: CheckboxTarget = request.Get<CheckboxTarget>("target");
        let id = request.Get<string>("id");
        let checked = request.Get<boolean>("checked");

        if (target == CheckboxTarget.Myle_Labs_GraphsControl) {
            store.LabGraphModel = store.LabGraphModel.set("AreAllGraphsChecked", !store.LabGraphModel.get("AreAllGraphsChecked"));
            let newChecks = this.helper.ChangeCheckStateFromAllICheckable(store.LabGraphModel.get("ObservationTypesCheckBoxes"), store.LabGraphModel.get("AreAllGraphsChecked"));
            store.LabGraphModel = store.LabGraphModel.set("ObservationTypesCheckBoxes", newChecks);
        }
        else if (target == CheckboxTarget.Myle_Labs_Graphs) {
            let newChecks = store.LabGraphModel.get("ObservationTypesCheckBoxes").toArray();
            newChecks.forEach(x => {
                if (x.Id == id)
                    x.Checked = checked;
            });

            store.LabGraphModel = store.LabGraphModel.set("ObservationTypesCheckBoxes", newChecks.toImmutable());
        }
    }
}

export { LabGraphsHandler };
